import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import CardWrapper from "./CardWrapper";
import "./DataEstate.scss";
import TableCardSelector from "./TableCardSelector";
import DataTagAllFilesTable from "./DataTagAllFilesTable";
import DataTagUsersTable from "./DataTagUsersTable";
import DataEstateSummary from "./DataEstateCards/DataEstateSummary";
import DataEstateDrives from "./DataEstateDrives";
import DataEstateSizeCard from "./DataEstateCards/DataEstateSizeCard";
import DataEstateRegulatedCard from "./DataEstateCards/DataEstateRegulatedCard";
import DataEstateCategoryCard from "./DataEstateCards/DataEstateCategoryCard";
import DataEstateSensitiveCard from "./DataEstateCards/DataEsateSensitiveCard";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_ALL_FILE_TYPES_DATA } from "../DataTagConstants";

export default function DataEstate() {
  const [showSensitiveBadge, setShowSensitiveBadge] = useState(false);
  const dispatch = useDispatch();
  
   const allDataSources = useSelector(
    (state) => state.dataTagReducer.selectedDataSource
  );

  const dataSourceId = useSelector(
      (state) => state.dataTagReducer.selectedDataSource?.id
    );

  const sensitiveCardData = useSelector(
    (state) => state.dataTagReducer.sensitiveCardData
  );

  const classificationStats = sensitiveCardData?.fileClassificationStatus || [];

  const isDataBase = useSelector((state) => state.dataTagReducer.isDatabase)

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_FILE_TYPES_DATA,
      payload: dataSourceId
    })
  },[dataSourceId])

  useEffect(() => {
    const regulatedDataEmpty =
      Array.isArray(classificationStats) && classificationStats.length === 0;

    if (regulatedDataEmpty) {
      setShowSensitiveBadge(true);
    } else {
      setShowSensitiveBadge(false);
    }
  }, [dataSourceId]);

  const cards = [
    { title: "Summary", component: <DataEstateSummary /> },
    { title: "Size Analysis", component: <DataEstateSizeCard /> },

    {
      title: showSensitiveBadge ? "Sensitivity" : "Regulated",
      component: showSensitiveBadge ? (
        <DataEstateSensitiveCard />
      ) : (
        <DataEstateRegulatedCard />
      ),
      rightElement: (
        <div className="de-regulated-actions">
          {/* Expand */}
          {showSensitiveBadge ? null : (
            <Popup
              modal
              className="de-popup"
              trigger={<span className="de-expand-icon">⤢</span>}
            >
              {(close) => (
                <div className="parent-popup">
                  <div className="de-popup-content">
                    <span className="de-popup-close" onClick={close}>
                      ✕
                    </span>

                    <DataEstateRegulatedCard expanded />
                  </div>
                </div>
              )}
            </Popup>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={showSensitiveBadge}
                onChange={() => setShowSensitiveBadge(!showSensitiveBadge)}
                color="primary"
                sx={{
                  transform: "scale(0.8)",
                  marginRight: "-6px",
                }}
              />
            }
          />
        </div>
      ),
    },

    {
      title: "Category",
      component: (
        <DataEstateCategoryCard
        />
      ),
    },
  ];

  const tabs = [
    { name: "Users", component: <DataTagUsersTable /> },
    { name: isDataBase ? "All Columns" :"All Files", component: <DataTagAllFilesTable /> },
    { name: isDataBase ? "All Tables" : "All Drives", component: <DataEstateDrives /> },
  ];

  return (
    <div className="dataEstate-container">
      <div className="de-container">
        {cards.map((card, index) => (
          <CardWrapper
            key={index}
            title={card.title}
            rightElement={card.rightElement}
          >
            {card.component}
          </CardWrapper>
        ))}
      </div>

      <div>
        <TableCardSelector tabs={tabs} />
      </div>
    </div>
  );
}
